import { render } from "./complaints_grievances.html?vue&type=template&id=7c29054b&external"
import script from "./complaints_grievances.js?vue&type=script&lang=js&external"
export * from "./complaints_grievances.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__